import i18next from "i18next";
import detector from "i18next-browser-languagedetector";

import common_fr from "./translations/fr/common.json";
import common_en from "./translations/en/common.json";

import {COOKIE_LANG_KEY, getCookieValueOrElse, setCookieValue} from "./services/CookiesUtils";

const DEBUG_LANG_DETECTOR = false;
export const DEFAULT_LOCALE = 'fr';
export const ACCEPTED_LOCALES = ['fr', 'en'];

/**
 * detect locale
 * server side cf. ExpressServer && common.getLocale
 */
export const retrieveCurrentLocale = () => {
    const queryParams = new URLSearchParams(window.location.search);

    // precedence about locale
    // 1) from user order (query param lang)
    const queryLang = queryParams.get('lang');
    if (ACCEPTED_LOCALES.includes(queryLang)) {
        DEBUG_LANG_DETECTOR && console.log(`queryParams lang (+set cookie+ ${queryLang})`);
        setCookieValue(COOKIE_LANG_KEY, queryLang);
        return queryLang;
    }
    // 2) from user historical preference (cookie)
    const cookieLang = getCookieValueOrElse(COOKIE_LANG_KEY, null);
    if (ACCEPTED_LOCALES.includes(cookieLang)) {
        DEBUG_LANG_DETECTOR && console.log(`cookieLang ${cookieLang}`);
        return cookieLang;
    }
    // 3) from server detection
    const docLang = document.documentElement.lang;
    if (ACCEPTED_LOCALES.includes(docLang)) {
        DEBUG_LANG_DETECTOR && console.log(`docLang ${docLang}`);
        return docLang;
    }
    DEBUG_LANG_DETECTOR && console.log(`DEFAULT_LOCALE:${DEFAULT_LOCALE}`);
    return DEFAULT_LOCALE;
}

//~ static defaults - dynamic default are set in CApp constructor
i18next
    .use(detector)
    .init({
        interpolation: {escapeValue: false},  // React already does escaping
        "lng": DEFAULT_LOCALE, // language to use
        resources: {
            fr: {common: common_fr},
            en: {common: common_en},
        },
        fallbackLng: DEFAULT_LOCALE, // use fr if detected lng is not available
    })
    .then(()=>{});

export default i18next;